import { Grid } from "@mui/material";
import CountryWiseMembers from "./CountryWiseMembers";
import { useEffect, useState } from "react";
import IndividualAnalysisMembers from "./IndividualAnalysisMembers";
import SkillWiseMembers from "./SkillWiseMembers";
import { IMemberWiseTableResults } from "features/dashboard/api/types";
import { GetMemberWiseTables } from "features/dashboard/api/hooks";

const MemberWiseTables = () => {
  const [data, setData] = useState<IMemberWiseTableResults>();

  const memberQuery = GetMemberWiseTables();

  useEffect(() => {
    if (memberQuery.data?.status === 200) {
      setData(memberQuery?.data?.apiData);
    }
  }, [memberQuery.data]);

  return (
    <>
      <Grid container spacing={2.5} sx={{ my: 1 }}>
        <Grid item sm={12} md={4} xs={12}>
          <CountryWiseMembers
            data={
              data?.countryWiseMemberResult ? data?.countryWiseMemberResult : []
            }
          />
        </Grid>
        <Grid item sm={12} md={4} xs={12}>
          <SkillWiseMembers
            data={
              data?.skillWiseMemberResult ? data?.skillWiseMemberResult : []
            }
          />
        </Grid>
        <Grid item sm={12} md={4} xs={12}>
          <IndividualAnalysisMembers
            data={
              data?.individualAnalysisResult
                ? data?.individualAnalysisResult
                : []
            }
          />
        </Grid>
      </Grid>
    </>
  );
};
export default MemberWiseTables;
